import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { Separator } from "@/components/ui/separator";

interface Deal {
  seller_name: string;
  seller_email?: string;
  seller_phone?: string;
  seller_address?: string;
  buyer_name: string;
  buyer_address?: string;
  buyer_current_on_contract: boolean;
  buyer_payment_history?: string;
}

interface PartyInfoTabProps {
  formData: Deal;
  onChange: (field: keyof Deal, value: any) => void;
}

export function PartyInfoTab({ formData, onChange }: PartyInfoTabProps) {
  return (
    <div className="space-y-6">
      {/* Seller Section */}
      <div>
        <h3 className="text-sm font-semibold mb-3">Seller Information</h3>
        <div className="grid grid-cols-2 gap-3">
          <div className="col-span-2">
            <Label htmlFor="seller_name">Name *</Label>
            <Input
              id="seller_name"
              value={formData.seller_name}
              onChange={(e) => onChange('seller_name', e.target.value)}
              required
            />
          </div>
          <div>
            <Label htmlFor="seller_email">Email</Label>
            <Input
              id="seller_email"
              type="email"
              value={formData.seller_email || ''}
              onChange={(e) => onChange('seller_email', e.target.value)}
            />
          </div>
          <div>
            <Label htmlFor="seller_phone">Phone</Label>
            <Input
              id="seller_phone"
              value={formData.seller_phone || ''}
              onChange={(e) => onChange('seller_phone', e.target.value)}
            />
          </div>
          <div className="col-span-2">
            <Label htmlFor="seller_address">Address</Label>
            <Input
              id="seller_address"
              value={formData.seller_address || ''}
              onChange={(e) => onChange('seller_address', e.target.value)}
            />
          </div>
        </div>
      </div>

      <Separator />

      {/* Buyer Section */}
      <div>
        <h3 className="text-sm font-semibold mb-3">Buyer Information</h3>
        <div className="grid grid-cols-2 gap-3">
          <div className="col-span-2">
            <Label htmlFor="buyer_name">Name *</Label>
            <Input
              id="buyer_name"
              value={formData.buyer_name}
              onChange={(e) => onChange('buyer_name', e.target.value)}
              required
            />
          </div>
          <div className="col-span-2">
            <Label htmlFor="buyer_address">Address</Label>
            <Input
              id="buyer_address"
              value={formData.buyer_address || ''}
              onChange={(e) => onChange('buyer_address', e.target.value)}
            />
          </div>
          <div className="col-span-2 flex items-center space-x-2">
            <Switch
              id="buyer_current_on_contract"
              checked={formData.buyer_current_on_contract}
              onCheckedChange={(checked) => onChange('buyer_current_on_contract', checked)}
            />
            <Label htmlFor="buyer_current_on_contract">Current on contract</Label>
          </div>
          <div className="col-span-2">
            <Label htmlFor="buyer_payment_history">Payment History</Label>
            <Textarea
              id="buyer_payment_history"
              value={formData.buyer_payment_history || ''}
              onChange={(e) => onChange('buyer_payment_history', e.target.value)}
              rows={2}
              placeholder="Payment history summary"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
